<template>
  <v-card
    outlined
    class="my-2 pb-12"
    loader-height="8"
    :loading="admin.productAttributeValuesLoading"
    :disabled="admin.productAttributeValuesLoading"
    min-width="600"
    :min-height="minCardHeight"
  >
    <v-dialog v-model="showConfirmationDialog" max-width="450">
      <v-card>
        <v-card-title
          ><v-icon class="mr-2" color="yellow darken-2"> mdi-alert </v-icon
          >CONFIRM</v-card-title
        >
        <v-card-text class="text-h5">
          Delete Attribute Value ({{ id }})?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="deleteProductAttributeValue">
            <v-icon> mdi-check-bold </v-icon>
          </v-btn>
          <v-btn
            color="error lighten-1"
            @click="showConfirmationDialog = false"
          >
            <v-icon> mdi-cancel </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar color="blue lighten-2" class="text-h4 text-uppercase" dark>
      {{ tabName }}
      <v-spacer></v-spacer>

      <v-icon>{{ app.detailIcon }}</v-icon>
    </v-toolbar>
    <v-card-text
      v-show="admin.selectedProductAttributeValue == null"
    ></v-card-text>
    <v-card-text v-show="admin.selectedProductAttributeValue != null">
      <v-overlay :opacity="0.9" absolute :value="showSaveOverlay">
        <v-btn color="success"> Attribute Value saved </v-btn>
      </v-overlay>
      <v-form v-model="valid">
        <v-text-field disabled v-model="id" label="ID" readonly></v-text-field>
        <v-autocomplete
          :items="admin.attributeList"
          label="Attribute"
          outlined
          item-text="name"
          item-value="id"
          v-model="attributeId"
          :rules="validation.selection"
          :hint="attributeDescription"
          persistent-hint
        ></v-autocomplete>
        <v-text-field
          v-show="controlType == 'int'"
          v-model="value"
          :rules="validation.Numeric"
          label="Value"
          required
          autofocus
        ></v-text-field>
        <v-text-field
          v-show="controlType == 'text'"
          v-model="value"
          :rules="validation.length150"
          label="Value"
          required
          autofocus
        ></v-text-field>
        <v-autocomplete
          v-show="controlType == 'multiselect'"
          v-model="value"
          :items="
            controlType == 'multiselect' ? attributeValuesMultiSelect : []
          "
          :loading="admin.attributeValuesLoading"
          attach
          chips
          label="Values"
          multiple
          item-text="label"
          item-value="value"
          deletable-chips
        ></v-autocomplete>
        <v-autocomplete
          v-show="controlType == 'dropdownlist'"
          v-model="value"
          :items="
            controlType == 'dropdownlist' ? attributeValuesDropDownList : []
          "
          :loading="admin.attributeValuesLoading"
          label="Values"
          item-text="label"
          item-value="value"
        ></v-autocomplete>
      </v-form>
    </v-card-text>
    <v-card-actions v-show="admin.selectedProductAttributeValue != null">
      <v-spacer />
      <v-btn
        dark
        color="blue darken-2"
        @click="saveProductAttributeValue"
        :disabled="!valid"
        >save</v-btn
      >
      <v-btn color="gray" @click="cancelCreation">cancel</v-btn>
      <v-btn
        v-show="!isNaN(id)"
        icon
        color="error"
        @click="confirmDeleteProductAttributeValue"
        ><v-icon>mdi-trash-can</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    components: {},
    data() {
      return {
        showSaveOverlay: false,
        showConfirmationDialog: false,
        valid: false
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      controlType: {
        get() {
          const attributeRecord = this.getSelectedAttribute();
          if (attributeRecord) return attributeRecord.controlType.toLowerCase();
          else return null;
        }
      },
      attributeValuesDropDownList: {
        get() {
          return this.admin.attributeValueList;
        }
      },
      attributeValuesMultiSelect: {
        get() {
          return this.admin.attributeValueList;
        }
      },
      selectedAttributeValues: {
        get() {
          return this.admin.selectedProductAttributeValue.value.split(',');
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductAttributeValue',
            property: 'value',
            value: value.join(',')
          });
        }
      },
      tabName: {
        get() {
          let tabName = 'Edit';
          if (
            this.admin.selectedProductAttributeValue &&
            this.admin.selectedProductAttributeValue.id != 'new'
          ) {
            const attributeRecord = this.getSelectedAttribute();
            if (attributeRecord) tabName = `Edit [${attributeRecord.name}]`;
          } else if (
            this.admin.selectedProductAttributeValue &&
            this.admin.selectedProductAttributeValue.id == 'new'
          ) {
            tabName = 'Add New Attribute Value';
          }
          return tabName;
        }
      },
      id: {
        get() {
          return this.admin.selectedProductAttributeValue?.id;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductAttributeValue',
            property: 'id',
            value: value
          });
        }
      },
      attributeId: {
        get() {
          return this.admin.selectedProductAttributeValue?.attributeId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductAttributeValue',
            property: 'attributeId',
            value: value
          });
          this.$store.dispatch('admin/getAttributeValueList', value);
        }
      },
      attributeDescription: {
        get() {
          if (this.admin.selectedProductAttributeValue) {
            const attributeRecord = this.getSelectedAttribute();
            if (attributeRecord) return attributeRecord.description;
            else return 'WARNING: matching attribute record not found';
          } else return 'WARNING: selected PAV not found';
        }
      },
      value: {
        get() {
          let currentValue = this.admin.selectedProductAttributeValue?.value;
          if (currentValue == null) return null;
          if (this.controlType == 'multiselect') return currentValue.split(',');
          else return currentValue;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductAttributeValue',
            property: 'value',
            value: value
          });
        }
      }
    },
    methods: {
      /**
       * Returns an attribute record for the currently selected PAV
       */
      getSelectedAttribute() {
        const attributeRecord = this.admin.attributeList.find(
          (x) => x.id == this.admin.selectedProductAttributeValue?.attributeId
        );
        if (attributeRecord) return attributeRecord;
        else return null;
      },
      /**
       * Cancels upsert of a product
       */
      cancelCreation() {
        this.$store.commit('admin/setSelectedProductAttributeValue', null);
      },
      /**
       * Saves the product currently being edited
       */
      saveProductAttributeValue() {
        this.$store
          .dispatch('admin/saveSelectedProductAttributeValue')
          .then(() => {
            this.showSaveOverlay = true;
            // refresh product list
            this.$store.dispatch('admin/getProductAttributeValueList');
            setTimeout(() => {
              this.showSaveOverlay = false;
              this.$store.commit(
                'admin/setSelectedProductAttributeValue',
                null
              );
            }, 1500);
          });
      },
      /**
       * Show confirm dialog
       */
      confirmDeleteProductAttributeValue() {
        this.showConfirmationDialog = true;
      },
      /**
       * Deletes a a product setting
       */
      deleteProductAttributeValue() {
        this.$store
          .dispatch('admin/deleteProductAttributeValue', this.id)
          .then(() => {
            this.$store.dispatch('admin/getProductAttributeValueList');
            this.showConfirmationDialog = false;
            this.$store.commit('admin/setSelectedProductAttributeValue', null);
          });
      }
    }
  };
</script>

<style scoped></style>
